import { render } from "./singleNews.vue?vue&type=template&id=c8697ae2"
import script from "./singleNews.vue?vue&type=script&lang=js"
export * from "./singleNews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__